

<template>
	<div class="assessment-container">
		<div class="assessment-head">
			<div>
				<span class="m-right-50">
					<i class="assessment-head_label">班级</i>
					<i class="assessment-head_val">{{ klassInfo }}</i>
				</span>
				<span>
					<i class="assessment-head_label">学生</i>
					<i class="assessment-head_val">{{ studentInfo.kid_name || "--" }}</i>
				</span><br /><br />
				<span class="m-right-50">
					<i class="assessment-head_label">评估体系</i>
					<i class="assessment-head_val">{{ assessmentTitle }}</i>
				</span>
				<span>
					<i class="assessment-head_label">评估进度</i>
					<i class="assessment-head_val">{{ assessmentProgress }}</i>
				</span>
			</div>
			
			<div v-if="!isArchived">
				<span v-if="['SENT'].includes(assessmentInfo.status)">
					<a-button ghost type="primary" class="m-right-20" @click="updateStatusHandle('INITIALIZED', '继续评估会将当前评估状态改变为“评估中”，并且从家长端撤回，是否继续？')">继续评估</a-button>
					<a-button ghost class="warning-btn" @click="updateStatusHandle('FINISHED', `确认撤回${studentInfo.kid_name}的评估报告？`)">撤回报告</a-button>
				</span>

				<span v-if="['FINISHED'].includes(assessmentInfo.status)">
					<a-button ghost type="primary" class="width-100 m-right-20" @click="updateStatusHandle('INITIALIZED', '继续评估会将当前评估状态改变为“评估中”，是否继续？')">继续评估</a-button>
					<a-button type="primary" @click="updateStatusHandle('SENT', '是否确认发送当前报告给家长？')">发送报告</a-button>
				</span>

				<span v-if="['INITIALIZED'].includes(assessmentInfo.status)">
					<a-button ghost class="width-100 m-right-20 warning-btn" @click="updateStatusHandle('SKIPPED', '无需评估操作会导致当前的评价信息丢失，是否继续？')">无需评估</a-button>
					<a-button ghost class="width-100 m-right-20" type="danger" @click="delHandle">删除评估</a-button>
					<a-button class="width-100 m-right-20" type="primary" @click="saveHandle('save')">保存</a-button>
					<a-button :class="['width-100', { 'complete-btn': isComplete }]" :disabled="!isComplete" @click="saveHandle('FINISHED')">完成评估</a-button>
				</span>
			</div>

		</div>
		<div class="assessment-content">
			<a-tabs v-model="activeKey">
				<a-tab-pane v-for="(child, index) in categoryList" :key="index" :tab="child.description">
					<div v-for="category in child.categories" :key="category.id">
						<div class="assessment-tab_title">{{ category.description }}</div>
						<div class="assessment-category" v-if="canEdit || optionIds.includes(item.id)" v-for="item in category.items" :key="item.id">
							<a-checkbox v-if="canEdit" @change="selectChange(item.id)" class="" :checked="optionIds.includes(item.id)">{{
								item.description }}</a-checkbox>
							<span v-else class="m-left-10">{{ item.description }}</span>
							<ul class="assessment-options">
								<li v-for="i in 6" :key="i" class="assessment-options_item" @click="assessHandle(item, i-1)"
									:class="{
										'assessment-options_item_selected': isSelected(item, i-1),
										'assessment-options_item_unchecked': !optionIds.includes(item.id),
										'assessment-options_item_empty': !getOption(item, i-1)
									}">
									<div v-if="getOption(item, i-1)">
										<div class="assessment-options_item_title">表现{{ getOption(item, i-1).score }}</div>
										<div>{{ getOption(item, i-1).description }}</div>
									</div>
								</li>
							</ul>

							<a-divider></a-divider>
						</div>
					</div>

					<div class="assessment-comment">
						<div class="assessment-comment_title">老师评价</div>
						<a-textarea v-if="canEdit" class="assessment-comment_input" :disabled="!canEdit" v-model="categoryComments[child.id]" placeholder="请输入老师评价"
							:auto-size="{ minRows: 3 }" @blur="saveHandle()" />

						<div v-else class="assessment-comment_input">{{ categoryComments[child.id] || "--" }}</div>
					</div>
				</a-tab-pane>

				<a-tab-pane :key="6" tab="总评">
					<div class="assessment-comment">
						<div class="assessment-comment_title">老师总评</div>
						<a-textarea v-if="canEdit" class="assessment-comment_input" :disabled="!canEdit" v-model="comment" placeholder="请输入老师总评"
							:auto-size="{ minRows: 3 }"  @blur="saveHandle()"/>
						<div v-else class="assessment-comment_input">{{ comment || "--" }}</div>
					</div>

					<div class="assessment-comment" v-if="['FINISHED', 'SENT'].includes(assessmentInfo.status)">
						<div class="assessment-comment_title">本期观察情况</div>
						<div class="assessment-comment_item" v-for="n in 6" :key="n" v-if="behavior(n-1).length">
							<span class="assessment-comment_item_title"><strong class="assessment-comment_item_num primary-color">{{ behavior(n-1).length }}</strong>项表现{{ n-1 }}</span>
							<span class="assessment-comment_item_content primary-color">{{ behavior(n-1).map(item => getCategoryInfo(item).description).join("、") }}</span>
						</div>

						<div>
							<div class="p-bottom-10">经过老师们的细心观察，发现{{ studentInfo.kid_name || "--" }}小朋友：</div>
							<div v-if="behavior(assessmentInfo.benchmark, true).length" class="m-bottom-10" style="line-height: 30px">
								在 <span class="primary-color">{{ behavior(assessmentInfo.benchmark, true).slice(0, 5).map(item => getCategoryInfo(item).description).join("、") }}</span>方面表现突出，高于同龄的孩子普遍水平，
								<span v-if="getExcellentOption.include_in_summary">尤其是 <span class="primary-color">{{ getCategoryInfo(behavior(assessmentInfo.benchmark, true)[0]).description }}</span> 方面，已经能 <span class="primary-color">{{ getExcellentOption.description }}</span></span>
							</div>
							<div v-if="behavior(assessmentInfo.benchmark).length" class="m-bottom-10" style="line-height: 30px">
								在<span class="primary-color m-left-5 m-right-5">{{ behavior(assessmentInfo.benchmark).slice(0, 5).map(item => getCategoryInfo(item).description).join("、") }}</span>方面发展均衡，行为表现非常符合该年龄段孩子的特点，希望继续努力，保持良好的状态!
							</div>
							<div v-if="unqualifiedBehavior(assessmentInfo.benchmark).length" class="m-bottom-10" style="line-height: 30px">
								在<span class="primary-color m-left-5 m-right-5">{{ unqualifiedBehavior(assessmentInfo.benchmark).slice(0, 5).map(item => getCategoryInfo(item).description).join("、") }}</span>方面需要关注，希望通过努力，宝贝能够做到：
							</div>
							<div class="p-left-20 m-bottom-5" v-for="(item, index) in getUnqualifiedOptions" :key="index" v-if="item.include_in_summary">● {{ item.description }}</div>
						</div>
					
					</div>
				</a-tab-pane>
			</a-tabs>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AssessmentService from "@/api/assessmentService";
import StudentService from "@/api/studentService";
export default {
	name: "assessment",
	data() {
		return {
			tempInfo: {},
			assessmentInfo: {},
			categoryList: [],
			categoryOptions: [],
			categoryComments: {},
			comment: "",
			assessmentTitle: "",
			studentInfo: {},
			activeKey: 0,
			benchmark: 0,
			isArchived: true,
		};
	},

	computed: {
		...mapGetters(["klassList"]),
		optionIds() {
			return this.categoryOptions
				.filter((item) => !item.is_skipped)
				.map((item) => item.option_id);
		},

		getOption() {
			return function(item, i) {
				if (!item.options) return null;
				const option = item.options.find((item) => item.score === i);
				return option;
			};
		},

		isSelected() {
			return function(item, i) {
				if (this.getOption(item, i) === null) return false;
				const matchedOption =
					this.categoryOptions
						.filter((item) => !item.is_skipped)
						.find((option) => option.option_id === item.id) || {};

				return matchedOption.score === i;
			};
		},

		assessmentProgress() {
			let totalOptions = this.categoryOptions.filter(
				(item) => !item.is_skipped
			);
			const compOptions = totalOptions.filter(
				(item) => item.score !== null
			);

			return `${compOptions.length} / ${totalOptions.length}`;
		},

		isComplete() {
			let totalOptions = this.categoryOptions.filter(
				(item) => !item.is_skipped
			);
			const compOptions = totalOptions.filter(
				(item) => item.score !== null
			);

			return compOptions.length === totalOptions.length;
		},

		klassInfo() {
			const result =
				this.klassList.find(
					(item) => item.id === this.assessmentInfo.klass_id
				) || {};

			return result.name || "--";
		},

		canEdit() {
			if (this.isArchived) {
				return false;
			}

			return this.assessmentInfo.status === "INITIALIZED";
		},

		unqualifiedBehavior() {
			return function(score) {
				return this.categoryOptions.filter((item) => {
					if (item.is_skipped) return false;
					return item.score < score;
				});
			};
		},

		behavior() {
			return function(score, isGreater) {
				return this.categoryOptions.filter((item) => {
					if (item.is_skipped) return false;
					if (isGreater) {
						return item.score > score;
					}
					return item.score === score;
				});
			};
		},

		getCategoryInfo() {
			return function(option) {
				let result = [];
				this.categoryList.forEach((item) => {
					item.categories.forEach((category) => {
						result = [...result, ...category.items];
					});
				});

				const category = result.find(
					(item) => item.id === option.option_id
				);
				return category || {};
			};
		},

		getExcellentOption() {
			const categoryOptions = this.behavior(this.assessmentInfo.benchmark, true);
			const category = this.getCategoryInfo(categoryOptions[0]);
			const option = this.getOption(category, categoryOptions[0].score);
			return option || {};
		},

		getUnqualifiedOptions () {
			const categoryOptions = this.unqualifiedBehavior(this.assessmentInfo.benchmark).slice(0, 5);
			return categoryOptions.map(category => this.getOption(this.getCategoryInfo(category), this.assessmentInfo.benchmark) || {})
		}
	},

	created() {
		this.$store.dispatch("getKlassListService");
		this.getTempInfo();
		this.getAssessmentInfo();
	},

	methods: {
		getTempInfo() {
			AssessmentService.getTemplateService({
				templateId: this.$route.query.template_id,
			}).then((res) => {
				this.categoryList = res.top_categories;
				this.assessmentTitle = res.title;
			});
		},

		getTask(taskId) {
			AssessmentService.getTaskService({ taskId }).then((res) => {
				this.isArchived = res.status === "ARCHIVED";
			});
		},

		getAssessmentInfo() {
			AssessmentService.getAssessmentService({
				assessmentId: this.$route.query.assessment_id,
			}).then((res = {}) => {
				const { items, category_comments, ...assessment } = res;
				this.assessmentInfo = assessment;
				this.categoryOptions = items.sort((a, b) => b.score - a.score);
				category_comments.forEach((item) => {
					this.categoryComments[item.category_id] = item.content;
				});

				this.getStudentHandle(assessment.student_id);
				this.getTask(res.task_id);
			});
		},

		selectChange(id) {
			const index = this.categoryOptions.findIndex(
				(item) => item.option_id === id
			);
			this.categoryOptions[index].is_skipped = !this.categoryOptions[
				index
			].is_skipped;
			this.saveHandle();
		},

		assessHandle(item, i) {
			if (!this.optionIds.includes(item.id)) return;
			if (!this.canEdit) return;
			const option = this.getOption(item, i);
			if (option === null) return;
			const matchedOption =
				this.categoryOptions
					.filter((item) => !item.is_skipped)
					.find((category) => category.option_id === item.id) || {};

			if (matchedOption.is_skipped) return;
			if (matchedOption.score === option.score) return;
			matchedOption.score = option.score;
			this.saveHandle();
		},

		getStudentHandle(studentId) {
			StudentService.getStudentService({ studentId }).then((res) => {
				this.studentInfo = res;
			});
		},

		delHandle() {
			this.$confirm({
				title: "提示信息",
				content: `是否删除 ${this.studentInfo.kid_name} 当前评估任务`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.delAssessmentService({
							assessmentId: this.assessmentInfo.id,
						})
							.then(() => {
								this.$message.success("删除成功");
								this.$router.back();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

		saveHandle(status) {
			const category_comments = [];
			for (let key in this.categoryComments) {
				category_comments.push({
					category_id: key,
					content: this.categoryComments[key].trim(),
				});
			}
			AssessmentService.updateAssessmentService({
				assessmentId: this.assessmentInfo.id,
				items: this.categoryOptions,
				comment: this.comment.trim(),
				category_comments,
			})
				.then(() => {
					if (status === "FINISHED") {
						this.updateStatusHandle(status, "是否已完成当前评估？");
					} else if (status === "save") {
						this.$message.success("保存成功");
					}
				})
				.catch(() => {
					this.$message.error("操作失败，请检查后重试");
				});
		},

		updateStatusHandle(status, tips) {
			this.$confirm({
				title: "提示信息",
				content: tips || "是否继续对当前评估任务的操作？",
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.updateAssessmentStatusService({
							assessmentId: this.assessmentInfo.id,
							status,
						})
							.then(() => {
								this.$message.success("操作成功");
								this.getAssessmentInfo();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

		completeHandle() {},
	},
};
</script>

<style lang="less" scoped>
.assessment {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;
		padding: 28px 28px 2px 30px;

		.warning-btn {
			border-color: #FFA647;
			color: #FFA647;
		}

		.complete-btn {
			background-color: #1AB752;
			color: #FFF;
		}
	}

	&-head {
		display: flex;
		flex-flow: nowrap row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 50px;

		&_label {
			display: inline-block;
			width: 100px;
			font-weight: bold;
			color: #3d3d3d;
		}

		&_val {
			display: inline-block;
			width: 200px;
		}
	}

	&-tab {
		&_title {
			margin: 20px 0 10px;
			color: #3d3d3d;
			font-weight: bold;
		}
	}

	// &-category {
	// 	padding: 5px 0;
	// 	margin: 10px 0;
	// 	box-shadow: 0 0 10px 2px #ccc
	// }

	&-options {
		display: flex;
		flex-flow: nowrap row;
		justify-content: space-around;
		align-items: stretch;
		list-style: none;
		margin: 10px 0 15px;
		padding-left: 20px;

		&_item {
			width: 10%;
			flex-grow: 1;
			padding: 10px;
			list-style: none;
			border: 1px solid #d9d9d9;
			border-radius: 3px;
			text-align: justify;
			margin: 0 10px;
			cursor: pointer;

			&_title {
				margin-bottom: 5px;
				font-weight: bold;
				text-align: center;
			}

			&_unchecked {
				cursor: not-allowed;
				border-color: rgba(0, 0, 0, 0.06);
				color: rgba(0, 0, 0, 0.06);
				// background-color: rgba(0, 0, 0, 0.03);
			}
			&_disabled {
				cursor: not-allowed;
				background-color: rgba(0, 0, 0, 0.08);
			}

			&_selected {
				border: 1px solid #1890ff;
				box-shadow: 0px 4px 10px 0px #bcd1e2;
			}

			&_empty {
				border-color: rgba(0, 0, 0, 0.06);
				color: rgba(0, 0, 0, 0.06);
				// background: rgba(0, 0, 0, 0.06);
			}

			// &:hover {
			// 	box-shadow: 0px 4px 10px 0px #BCD1E2;
			// }
		}
	}

	&-comment {
		padding: 20px 0 30px;

		&_title {
			margin-bottom: 15px;
			font-weight: bold;
			color: #3d3d3d;
		}

		&_input {
			box-shadow: none;
		}

		&_item {
			display: flex;
			flex-flow: nowrap row;
			justify-content: flex-start;
			align-items: flex-start;
			margin-bottom: 30px;
			line-height: 30px;

			&_title {
				width: 100px;
			}

			&_content {
				width: 50%;
				flex-grow: 1;
			}
			&_num {
				display: inline-block;
				width: 24px;
				margin-right: 8px;
				font-size: 18px;
				text-align: right;
			}
		}
	}
}
</style>
